import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IClinicRoom } from 'interfaces'
import { RootState } from 'store'

interface IState {
  roomSelected: IClinicRoom
}

const initialState: IState = {
  roomSelected: {}
}

export const receiveSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    selectRoomAction: (state: IState, action: PayloadAction<IClinicRoom>) => {
      state.roomSelected = action.payload
    },
    resetReceiveStateAction: () => initialState
  }
})

export const { selectRoomAction, resetReceiveStateAction } =
  receiveSlice.actions
export const receiveSelector = (state: RootState) => state.receiveReducer
export default receiveSlice.reducer
